export default __webpack_public_path__ + "static/media/Oval.6fb86294.svg";